module.exports = __webpack_public_path__ + "img/home_pic_3.0_2.7eea397a.webp";